import React, { useState } from 'react'
import TextEditor from '../common/TextEditor';
import CustomAddList from '../common/CustomAddList';
import TextBox from '../common/TextBox';
import { FaFileAlt } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { templateFormData } from '../lib/TemplatesData';

const ResumeForm = ({ getFormData, templateId = 1 }) => {
    let storedData = localStorage.getItem("formData");
    const [formData, setFormData] = useState(storedData != null ? JSON.parse(storedData) : {});
    const templateFormDataById = templateFormData[templateId - 1];
    const { educationSummary = true, skillExperience = true, skillTag = true, summary = true, achievements = false, courses = false, isSkillExperienceDisabledByDefault = false } = templateFormDataById;
    const [isSkillExperience, setIsSkillExperience] = useState(skillExperience)
    const employmentHistory = [
        {
            name: "jobTitle",
            label: "Job Title",
            inputType: 'text'
        },
        {
            name: "employer",
            label: "Employer",
            inputType: 'text'
        },
        {
            name: "date",
            label: "Start & End Date",
            inputType: 'dateTime'
        },
        {
            name: "city",
            label: "City",
            inputType: 'text'
        },
        {
            name: "desc",
            label: "Description",
            inputType: 'textBox'
        },
    ];
    const educationList = [
        {
            name: "degree",
            label: "Degree",
            inputType: 'text'
        },
        {
            name: "college",
            label: "College",
            inputType: 'text'
        },
        {
            name: "date",
            label: "Start & End Date",
            inputType: 'dateTime'
        },
        {
            name: "city",
            label: "City",
            inputType: 'text'
        },
        educationSummary && {
            name: "desc",
            label: "Description",
            inputType: 'textBox'
        },
    ];

    const projectList = [
        {
            name: "title",
            label: "Title",
            inputType: 'text'
        },
        {
            name: "techStack",
            label: "Tech Stack",
            inputType: 'text'
        },
        {
            name: "link",
            label: "Project Link",
            inputType: 'text'
        },
        {
            name: "sourceCode",
            label: "Source Code",
            inputType: 'text'
        },
        {
            name: "desc",
            label: "Description",
            inputType: 'textBox'
        },
    ];

    const socialList = [
        {
            name: 'label',
            label: 'Label',
            inputType: 'text'
        },
        {
            name: 'link',
            label: 'Link',
            inputType: 'text'

        }
    ]
    const skillList = [
        {
            name: 'skill',
            label: 'Skill',
            inputType: 'text'
        },

        {
            name: 'level',
            label: 'Level',
            inputType: 'levelIndicator'
        },
        skillTag && {
            name: 'tag',
            label: "Tag",
            inputType: 'selectOption'
        }
    ]

    const achievementList = [
        {
            name: 'rank',
            label: 'Rank/Medal',
            inputType: 'text'
        },
        {
            name: 'competition',
            label: 'Competition',
            inputType: 'text'
        }
    ]

    const courseList = [
        {
            name: 'course',
            label: 'Coursework',
            inputType: 'text'
        },
        {
            name: 'link',
            label: 'Certification Link',
            inputType: 'text'
        }
    ]

    const handleCustomFormData = (customFormData, customLabel) => {
        let tempFormData = {
            ...formData,
            [customLabel]: customFormData,

        }


        setFormData(tempFormData);
        getFormData(tempFormData)
    }


    const handleChange = (e) => {
        let tempFormData = {
            ...formData,
            [e.target.name]: e.target.value,
        }
        setFormData(tempFormData);
        getFormData(tempFormData)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
    };

    const handleTextEditorChange = (val, inputName) => {
        const htmlContent = val.replace(/<p>\s*<br\s*\/?>\s*<\/p>/g, '');
        let tempFormData = {
            ...formData,
            [inputName]: htmlContent,
        }

        setFormData(tempFormData);
        getFormData(tempFormData)
    }

    const location = useLocation();

    const handleSkillExperience = (e) => {
        if(skillTag){
            setIsSkillExperience(e.target?.checked)
        }
    }

    return (
        <div className='bg-slate-50 md:w-1/2 p-5'>
            <Link to={'/resume-preview-layout'} state={{
                index: location?.state?.index
            }} prop className='flex md:hidden fixed right-4 bottom-5 items-center bg-blue-600 z-50 w-fit px-3 py-3 rounded-full'>
                <span className='text-base font-bold text-white'>Preview & Download</span> <FaFileAlt className='ml-1 text-xl text-white' />
            </Link>
            <div>
                <h1 className='text-xl font-bold'>Personal Details</h1>
                <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-6">
                    <TextBox
                        label="First Name"
                        type="text"
                        inputName="firstName"
                        onChange={(e) => handleChange(e)}
                        inputValue={formData.firstName} />
                    <TextBox
                        label="Last Name"
                        type="text"
                        inputName="lastName"
                        onChange={(e) => handleChange(e)}
                        inputValue={formData.lastName} />
                    <TextBox
                        label="Email"
                        type="email"
                        inputName="email"
                        onChange={(e) => handleChange(e)}
                        inputValue={formData.email} />
                    <TextBox
                        label="Phone"
                        type="tel"
                        inputName="phone"
                        onChange={(e) => handleChange(e)}
                        inputValue={formData.phone} />
                    <TextBox
                        label="Country"
                        type="text"
                        inputName="country"
                        onChange={(e) => handleChange(e)}
                        inputValue={formData.country} />
                    <TextBox
                        label="City"
                        type="text"
                        inputName="city"
                        onChange={(e) => handleChange(e)}
                        inputValue={formData.city} />
                </form>

            </div>
            {summary && <div className='mt-2'>
                <h1 className='text-xl font-bold'>Professional Summary</h1>
                <TextEditor
                    label={`Write 2-4 short & energetic sentences to interest the reader! Mention your role, experience & most importantly - your biggest achievements, best qualities and skills.`} placeholder={`e.g. Detail-oriented software engineer with 5+ years of experience in developing web applications. `}
                    onChange={(val) => handleTextEditorChange(val, 'summary')}
                    inputValue={formData.summary}
                />
            </div>}
            <div className='mt-2'>
                <h1 className='text-xl font-bold'>Employement History</h1>
                <CustomAddList label={`Show your relevant experience (last 10 years). Use bullet points to note your achievements, if possible - use numbers/facts (Achieved X, measured by Y, by doing Z).`}
                    buttonLabel={'Add Employement'}
                    addList={employmentHistory}
                    dataList={formData.Experience}
                    customListFormData={(customFormData) => handleCustomFormData(customFormData, 'Experience')}
                />
            </div>

            <div className='mt-2'>
                <h1 className='text-xl font-bold'>Education</h1>
                <CustomAddList label={`List your educational qualifications. Include degree, institution, location, graduation year.`}
                    buttonLabel={'Add Education'}
                    isEducationList={true}
                    addList={educationList}
                    dataList={formData.Education}
                    customListFormData={(customFormData) => handleCustomFormData(customFormData, 'Education')}
                />
            </div>


            <div className='mt-2'>
                <h1 className='text-xl font-bold'>Websites & Social Links</h1>
                <CustomAddList label={`Provide links to showcase your work or profile (e.g., LinkedIn, GitHub, Portfolio, Personal Website).`}
                    buttonLabel={'Add Link'}
                    addList={socialList}
                    isSocialList={true}
                    dataList={formData.links}
                    customListFormData={(customFormData) => handleCustomFormData(customFormData, "links")}
                />
            </div>

            <div className='mt-2'>
                <h1 className='text-xl font-bold'>Personal Projects</h1>
                <CustomAddList label={`Highlight your top projects. Include project name, role, technologies used, and measurable outcomes`}
                    buttonLabel={'Add Projects'}
                    addList={projectList}
                    isProjectList={true}
                    dataList={formData.Projects}
                    customListFormData={(customFormData) => handleCustomFormData(customFormData, "Projects")}
                />
            </div>

            <div className='mt-2'>
                <div className='flex justify-between items-center'>
                    <h1 className='text-xl font-bold'>Skills</h1>
                    <div className='flex group items-center'>
                        <div className='flex items-center transform ease-in delay-75 scale-0 transition-all group-hover:scale-100 z-0'>
                            <span class="w-72 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-1 px-2 mr-3 ">
                                {isSkillExperienceDisabledByDefault ? 'Skill Experience is not available in this template.' : isSkillExperience ? 'Disable this to remove experience for the selected skills' : 'Enable this to add experience for the selected skills'}

                            </span>
                            <div className='w-3 h-3 bg-gray-700 transfor ease-out delay-0
                             rotate-45 absolute right-2'></div>
                            </div> 

                        <label class="inline-flex items-center cursor-pointer ">
                            <input type="checkbox" checked={isSkillExperience} onChange={handleSkillExperience} class="sr-only peer" />
                            <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                        </label>
                    </div>
                </div>
                {isSkillExperienceDisabledByDefault && <div className='md:hidden text-xs text-muted-foreground font-semibold'>(Note: Skill Experience is not available in this template.)</div>}
                <CustomAddList label={`List your key technical and soft skills. Prioritize those relevant to the job you’re applying for`}
                    buttonLabel={'Add Skill'}
                    addList={skillList}
                    skillExperienceEnabled={isSkillExperience}
                    isSkill={true}
                    dataList={formData.Skills}
                    skillTag={skillTag}
                    isSkillExperienceDisabledByDefault={isSkillExperienceDisabledByDefault}
                    customListFormData={(customFormData) => handleCustomFormData(customFormData, "Skills")}
                />
            </div>

            {achievements &&
                <div className='mt-2'>
                    <h1 className='text-xl font-bold'>Achievements</h1>
                    <CustomAddList label={`Share your major achievements. Use numbers to quantify impact where possible (e.g., Awarded X for Y, Increased Z by %).`}
                        buttonLabel={'Add Achievments'}
                        addList={achievementList}
                        dataList={formData?.Achievements}
                        customListFormData={(customFormData) => handleCustomFormData(customFormData, "Achievements")}
                    />
                </div>
            }

            {
                courses && <div className='mt-2'>
                    <h1 className='text-xl font-bold'>CourseWork</h1>
                    <CustomAddList label={`Include any relevant academic or professional coursework. Specify course titles and highlight key learnings.`}
                        buttonLabel={'Add Relevant Course'}
                        addList={courseList}
                        isCourseList={true}
                        dataList={formData?.courses}
                        customListFormData={(customFormData) => handleCustomFormData(customFormData, "courses")}
                    />
                </div>
            }

        </div>
    )
}

export default ResumeForm